import Konva from 'konva';

import { Element } from '../../equipment/models/elements/element';
import { IPlanogram } from './planogram';
import { Point } from '../../core/models/point';
import { POSMaterial } from './POSMaterials/POSMaterial';
import { ProductGroup } from './product-group';

export abstract class PlanogramViewBehavior {
	protected planogram: IPlanogram;
	protected element: Element;
	protected scale: number;
	protected beginPoint: Point;

	get isDetailedBehavior (): boolean {
		return !!this.element;
	}

	protected constructor(planogram: IPlanogram, detailedElement: Element, scale: number, beginPoint: Point) {
		this.planogram = planogram;
		this.element = detailedElement;
		this.scale = scale;
		this.beginPoint = beginPoint;
	}

	abstract convertCanvasPointToPlanogram(point: Point): Point;

	abstract convertPlanogramPointToCanvas(point: Point): Point;

	abstract getActiveProductGroups(activeProducts: Array<ProductGroup>): Array<Array<ProductGroup>>;

	abstract getAnchorElement(product: ProductGroup, point: Point): Element;

	abstract getCorrectZCoordinate(element: Element, z: number, product: ProductGroup): number;

	abstract getOffset(): Point;

	abstract getPoint(product: ProductGroup, canvasElement: Konva.Group): Point;

	abstract getProductAngle(element: Element, point: Point): number;

	abstract moveProducts(productGroups: Array<ProductGroup>, horizontal: number, vertical: number): boolean;

	abstract movePOSMaterials(materials: Array<POSMaterial>, horizontal: number, vertical: number): boolean;
}